import type { Rarity } from "@/domain/gems-game/domain/lib/Earning";
import { base } from "@biom3/design-tokens";
import { ButtCon, Video } from "@biom3/react";
import { Dialog, DialogContent } from "@mui/material";
import { useMemo } from "react";

interface RedeemTicketVideoModalProps {
  rarity: Rarity;
  onClose?: () => void;
}

export const RedeemTicketVideoModal = ({
  rarity,
  onClose,
}: RedeemTicketVideoModalProps) => {
  const videoUrl = useMemo(() => {
    // Videos are named after the rarity level (Common.webm, Rare.webm, etc.)
    return `/video/rewards/${rarity}.webm`;
  }, [rarity]);

  return (
    <Dialog
      open={true}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      slotProps={{
        paper: {
          sx: {
            border: { xs: "none", sm: "2px solid white" },
            borderRadius: { xs: 0, sm: "16px" },
            backgroundColor: base.color.translucent.standard[1000],
          },
        },
      }}
    >
      <ButtCon
        icon="Close"
        variant="tertiary"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: "base.spacing.x4",
          top: "base.spacing.x4",
          zIndex: 1,
        }}
      />
      <DialogContent
        sx={{
          padding: 0,
          overflow: "hidden",
        }}
      >
        <Video
          sx={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
          }}
          mimeType="video/webm"
          videoUrl={videoUrl}
          autoPlay
          muted
          onEnded={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
